import { render } from "./MonitorHeader.vue?vue&type=template&id=6e99b27a&scoped=true"
import script from "./MonitorHeader.vue?vue&type=script&lang=js"
export * from "./MonitorHeader.vue?vue&type=script&lang=js"

import "./MonitorHeader.vue?vue&type=style&index=0&id=6e99b27a&scoped=true&lang=css"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e99b27a"]])

export default __exports__